// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.iconos-centrados {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
}

.filtros-container .d-flex {
  gap: 1rem !important;
}
.filtros-container .btn:not(:last-child) {
  margin-right: 1rem;
}

i.text-warning {
  color: #ffc107 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/expedientes-listar/expedientes-listar.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;AACF;;AAGE;EACE,oBAAA;AAAJ;AAII;EACE,kBAAA;AAFN;;AAMA;EACE,yBAAA;AAHF","sourcesContent":[".iconos-centrados {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 0.5rem; // Espacio entre los íconos\n}\n\n.filtros-container {\n  .d-flex {\n    gap: 1rem !important; // Forzar espacio entre botones\n  }\n  \n  .btn {\n    &:not(:last-child) {\n      margin-right: 1rem;\n    }\n  }\n}\ni.text-warning {\n  color: #ffc107!important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
